import { render, staticRenderFns } from "./CommissionStatistics.vue?vue&type=template&id=aa6cfa38&scoped=true"
import script from "./CommissionStatistics.vue?vue&type=script&lang=js"
export * from "./CommissionStatistics.vue?vue&type=script&lang=js"
import style0 from "./CommissionStatistics.vue?vue&type=style&index=0&id=aa6cfa38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6cfa38",
  null
  
)

export default component.exports